import React from "react";
import { useNavigate } from "react-router-dom";

const HumanDigitalTeams = () => {
  const navigate = useNavigate();
  const deliveryCards = [
    {
      text: "Keep teams lean and senior, focused on solving business problems",
      emphasis: "Keep teams lean and senior",
    },
    {
      text: "Use AI coworkers to scale repetitive and automatable tasks",
      emphasis: "Use AI coworkers",
    },
    {
      text: "Embed with clients, so that knowledge transfers - not just outputs",
      emphasis: "Embed with clients",
    },
  ];

  const renderCardText = (text, emphasis) => {
    const parts = text.split(emphasis);
    return (
      <>
        <span className="font-bold">{emphasis}</span>
        {parts[1]}
      </>
    );
  };

  return (
    <div className="w-full py-12">
      <div className="w-[88%] lg:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-12 lg:mb-16">
          <h2 className="text-[32px] lg:text-[48px] xl:text-[56px] text-white RoobertLight leading-[120%] mb-4">
            A new way to deliver - with human + digital teams
          </h2>
          <h3 className="text-[20px] lg:text-[24px] xl:text-[28px] text-white RoobertMedium leading-[120%]">
            We help clients:
          </h3>
        </div>

        {/* Delivery Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-12 lg:mb-16">
          {deliveryCards.map((card, index) => (
            <div
              key={index}
              className="bg-white p-6 lg:p-8 flex flex-col justify-center min-h-[200px] lg:min-h-[240px] relative"
            >
              <p className="text-black RoobertRegular text-[16px] lg:text-[18px] leading-[140%]">
                {renderCardText(card.text, card.emphasis)}
              </p>
              <div className="border-r-4 border-t-4 border-fluoro-green absolute top-0 right-0 w-1/4 h-1/2"></div>
            </div>
          ))}
        </div>

        {/* Concluding Section */}
        <div>
          <p className="text-white RoobertRegular text-[16px] lg:text-[18px] leading-[140%] mb-6">
            We're not replacing your teams. We're making them faster, smarter, and better equipped.
          </p>
          
          {/* Call-to-Action Button */}
          <button
            className="bg-[#66FF00] text-black px-4 py-4 RoobertSemiBold text-[16px] lg:text-[18px] hover:bg-[#5AE600] transition-colors duration-200 tracking-wider"
            onClick={() => navigate("/contact-us")}
          >
            Schedule a meeting with us
          </button>
        </div>
      </div>
    </div>
  );
};

export default HumanDigitalTeams;
